import { Box } from '@chakra-ui/react';

const Divider = (
  <Box
    width="100%"
    borderColor="neutralPrimaryBorder"
    borderTopWidth="1px"
    borderStyle="solid"
  />
);

export default Divider;
